module.exports = __webpack_public_path__ + "static/pr-op-management-130cbdf93f66288fad663dc3011c18b5.png";